import styles from './styles.module.scss';

import cn from 'classnames';
import React, { forwardRef } from 'react';

const PureInputBase = ({ className, forwardedRef, ...props }) => (
  <input
    {...{
      className: cn(styles.input_base, className),
      ref: forwardedRef,
      ...props,
    }}
  />
);

const InputBase = forwardRef((props, ref) => <PureInputBase {...{ ...props, forwardedRef: ref }} />);

export { PureInputBase };
export default InputBase;
